import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'
import { Loading } from '@makyoapp/makyo-ui'

import { DbProvider, useDbContext } from '@/context/DbContext'
import { useOrgPerm } from '@/hooks/useOrgPerm'
import { DB_ID_PARAM } from '@/shared/constants'
import { WrapperProps } from '@/shared/routes'
import Layout from '@/components/Layout'
import { PageUnauthorized } from '@/components/PageUnauthorized'

const OrgDatabaseList = lazy(() => import('./OrgDatabaseList'))
const OrgDatabaseGridPage = lazy(() => import('./OrgDatabaseGrid').then((m) => ({ default: m.OrgDatabaseGridPage })))

function DbRoutes() {
  const { isLoading } = useDbContext()

  return isLoading ? (
    <Loading />
  ) : (
    <React.Suspense fallback={<Loading />}>
      <Routes>
        <Route index element={<OrgDatabaseList title='Databases' />} />
        <Route path={`${DB_ID_PARAM}/*`} element={<OrgDatabaseGridPage />} />
      </Routes>
    </React.Suspense>
  )
}

/**
 * permission checking to display db page and handle db detail route
 */
export default function OrgDatabaseRoutes({ title }: WrapperProps) {
  const canListDb = useOrgPerm(OrgPermission.DBViewListOfDatabases)

  return !canListDb ? (
    <Layout title={title}>
      <PageUnauthorized />
    </Layout>
  ) : (
    <DbProvider>
      <DbRoutes />
    </DbProvider>
  )
}
